import { useToggle } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import Popover, { PopoverProps } from 'components/Popover';
import { socialShareModalAccountSelectBlock as block } from '../utils';
import AccountsList from './AccountsList';
import SwitchAccounts from './SwitchAccounts';

export type AccountsSelectorProps = Pick<PopoverProps, 'triggerElement'> & {
  isOpen: boolean;
  onClose: () => void;
};

const AccountsSelector: React.FC<AccountsSelectorProps> = ({
  triggerElement,
  isOpen,
  onClose,
}) => {
  const {
    value: isShowingSwitchAccountConfirmation,
    toggleOn: showSwitchAccountConfirmation,
    toggleOff: hideSwitchAccountConfirmation,
  } = useToggle(false);

  const handleClose = useCallback(() => {
    hideSwitchAccountConfirmation();
    onClose();
  }, [hideSwitchAccountConfirmation, onClose]);

  return (
    <Popover
      isDismissable
      placement="bottom"
      offset={10}
      isOpen={isOpen}
      triggerElement={triggerElement}
      className={block('accounts-selector-container')}
      onClose={handleClose}
    >
      {isShowingSwitchAccountConfirmation ? (
        <SwitchAccounts
          onCancel={hideSwitchAccountConfirmation}
          onClose={handleClose}
        />
      ) : (
        <AccountsList
          onSwitchAccount={showSwitchAccountConfirmation}
          onClose={handleClose}
        />
      )}
    </Popover>
  );
};

export default AccountsSelector;
